export const partnerData = {
    "event": {
        "exhibitorsTypes": [
            {
                "name": "host-partner",
                "id": "RmllbGRWYWx1ZV8yMzkwMTI2Ng==",
                "position": 0
            },
            {
                "name": "Host Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "position": 0
            },
            {
                "name": "strategic-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "position": 0
            },
            {
                "name": "founding-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1Mg==",
                "position": 0
            },
            {
                "name": "enablement-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE0OQ==",
                "position": 0
            },
            {
                "name": "country-pavilion-sponsors",
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "position": 0
            },
            {
                "name": "platinum-sponsors",
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "position": 0
            },
            {
                "name": "pavilion-sponosr",
                "id": "RmllbGRWYWx1ZV8yMzk0MjEyNQ==",
                "position": 0
            },
            {
                "name": "emerald-sponsor",
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "position": 0
            },
            {
                "name": "Gold Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "position": 0
            },
            {
                "name": "Silver Sponsors",
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "position": 0
            },
            {
                "name": "grif-platinum-sponsor",
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "position": 0
            },
            {
                "name": "grif-exhibitor",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3OQ==",
                "position": 0
            },
            {
                "name": "Strategic Partner",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMQ==",
                "position": 0
            },
            {
                "name": "start-up-exhibitor",
                "id": "RmllbGRWYWx1ZV8yMzEwNjg2Mw==",
                "position": 0
            },
            {
                "name": "un-tourism-innovation-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "position": 0
            },
            {
                "name": "coffee-sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczNw==",
                "position": 0
            },
            {
                "name": "water-station-sponsor",
                "id": "RmllbGRWYWx1ZV8yNDE1NjE5Nw==",
                "position": 0
            },
            {
                "name": "after-party-host",
                "id": "RmllbGRWYWx1ZV8yMjQ0MjEzMw==",
                "position": 0
            },
            {
                "name": "confectionary-cafe-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA3OQ==",
                "position": 0
            },
            {
                "name": "refreshment-bar-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4MA==",
                "position": 0
            },
            {
                "name": "mini-golf-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzk0Mjg1Ng==",
                "position": 0
            },
            {
                "name": "clinic-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mg==",
                "position": 0
            },
            {
                "name": "networking-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mw==",
                "position": 0
            },
            {
                "name": "official-carriers",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4NA==",
                "position": 0
            },
            {
                "name": "media-partner",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "position": 0
            },
            {
                "name": "supporter",
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "position": 0
            },
            {
                "name": "culinary-and-concept-tour-partners",
                "id": "RmllbGRWYWx1ZV8yMDc3MjE1MQ==",
                "position": 0
            },
            {
                "name": "Organiser",
                "id": "RmllbGRWYWx1ZV8xNTAzNDc1NQ==",
                "position": 0
            }
        ]
    },
    "exhibitors": [
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDA=",
        "name": "Wyndham Hotels & Resorts",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/d8f0924ea9164f218a5475faabf39906.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDE=",
        "name": "Rove Hotels",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/d2c1487560c3423fb490d96cb471da87.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDI=",
        "name": "QUO",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDM=",
        "name": "IHCL",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/57a3cd54a7b04558baf5aa653c5a1cb2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDQ=",
        "name": "Knight Frank",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDU=",
        "name": "Rotana Hotel Management Corporation PJSC",
        "logoUrl": "https://static.swapcard.com/public/images/6db66e9817ac450693fda983d6f06dc5.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDY=",
        "name": "NEOM",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/02f00839db2b4b5c87f2596c203ea173.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDc=",
        "name": "Al Khozama",
        "logoUrl": "https://static.swapcard.com/public/images/8aacb32154ea43c390d7cc4d9800741b.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1Nw==",
                "value": "host-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Host Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDg=",
        "name": "ClubMed - All-Inclusive beach and mountain Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/be4d8703637446998610d447a7258835.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NDk=",
        "name": "Time Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/f190fc235cd4457e838b4d364ac19655.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NTA=",
        "name": "Taiba Investments",
        "logoUrl": "https://static.swapcard.com/public/images/83639d5b026948dca951d99b32b097af.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg2MA==",
                "value": "founding-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Founding Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NTE=",
        "name": "Red Sea Global",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/840416ae058446069c9e02d645798d66.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NTI=",
        "name": "Louvre Hotels Group / Golden Tulip MENA",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/d5f080b116e948d9b329055a8278c318.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NTM=",
        "name": "Accor",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/c62a803df9754fb8874df76d6b05d7c3.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4NTk=",
        "name": "Melia Hotels International",
        "logoUrl": "https://static.swapcard.com/public/images/3e47ed6f341644239754e6dc66c2af54.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4MTI4Njc=",
        "name": "Ark People Solutions",
        "logoUrl": "https://static.swapcard.com/public/images/047f55dacb7a4ca882bfa00fadd9735d.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4OTcwODU=",
        "name": "Saudi Icon",
        "logoUrl": "https://static.swapcard.com/public/images/67bc4ccbefbd4fe287bc9283749c3ae4.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4OTcwOTA=",
        "name": "Aleph Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/f0b699e3707e4ed6babef63d88d31cb9.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4OTcwOTc=",
        "name": "Compass Project Consulting",
        "logoUrl": "https://static.swapcard.com/public/images/3240f0c53e3f4fa8b1e2f2209ea7e778.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE4OTgxMjI=",
        "name": "AtkinsRéalis",
        "logoUrl": "https://static.swapcard.com/public/images/f4c57563207646019baf3737048dd86d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5NDQ3MTk=",
        "name": "ARC-IDC",
        "logoUrl": "https://static.swapcard.com/public/images/30e4dd9839a848bf8d41eee7bb23a859.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5NDQ3MjA=",
        "name": "Valor Hospitality Partners",
        "logoUrl": "https://static.swapcard.com/public/images/5e3c0070965e44ee8037da57de8144af.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5NTM5OTM=",
        "name": "Minor Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/c0028b8b411443839af02c55665ef6e1.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5NzQ2MDQ=",
        "name": "Shaza Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/be86957ee5a349d89eb2f22761541f99.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5ODEwMjE=",
        "name": "WhiteWater",
        "logoUrl": "https://static.swapcard.com/public/images/74976fd68959485798899fcf91ae212a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzE5OTY5MTE=",
        "name": "Tourism Development Fund (TDF)",
        "logoUrl": "https://static.swapcard.com/public/images/6ef376b8f3c84b9d839ba84c94aad43b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg2MQ==",
                "value": "enablement-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Enablement Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwMTg2NDc=",
        "name": "Amsa Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/c729b498798d4e00ad3646408808e42c.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwMjQ0NTc=",
        "name": "Radisson Hotel Group",
        "logoUrl": "https://static.swapcard.com/public/images/a950762cd2cc49bb91ad051d10daef75.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwMjg4Nzg=",
        "name": "Al Rajhi Bank",
        "logoUrl": "https://static.swapcard.com/public/images/e5fcb697f69843b38d6d34aab5c0bea0.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwNjQ3ODk=",
        "name": "The Ascott Limited",
        "logoUrl": "https://static.swapcard.com/public/images/4eef8075323e490686bd0abebca93127.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwODQwMDk=",
        "name": "Mandarin Oriental Al Faisaliah, Riyadh",
        "logoUrl": "https://static.swapcard.com/public/images/7991f72f3ba642a0aa98313fd616fee8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1Nw==",
                "value": "host-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Host Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTEyMjE=",
        "name": "Marriott",
        "logoUrl": "https://static.swapcard.com/public/images/8eeab88d36c244a2945f09839242c7b5.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTEyNzE=",
        "name": "Neoleap - Financial Global Digital Solutions Company",
        "logoUrl": "https://static.swapcard.com/public/images/24cce192f7d9483eafcd6a876a3cfbb8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTMxNDE=",
        "name": "BWH Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/41baf781353e49979ce09d0cef50100f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTY1MDM=",
        "name": "Ministry of Tourism - Saudi Arabia",
        "logoUrl": "https://static.swapcard.com/public/images/54c8b545fe464499b8844827c9ffd803.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg5Nzk4NA==",
                "value": "strategic-enabler",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Enabler"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTY1MTU=",
        "name": "STORY Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/97787135cc034584a7aee61640ecec0d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTY1MjI=",
        "name": "JLL",
        "logoUrl": "https://static.swapcard.com/public/images/a47422b95d204701b9345beae287d9b1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTg4OTU=",
        "name": "Rua Al Madinah Holding Company",
        "logoUrl": "https://static.swapcard.com/public/images/9eb5700532ac44ee84b208cac2d00f45.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIwOTkyNTI=",
        "name": "JT+Partners",
        "logoUrl": "https://static.swapcard.com/public/images/1efcbb16da3645b3b38ed6c6b24534d1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMTg5MDA=",
        "name": "Hozpitality",
        "logoUrl": "https://static.swapcard.com/public/images/2099c3626eac40859b572b82867581ed.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMTg5MDk=",
        "name": "Franchising",
        "logoUrl": "https://static.swapcard.com/public/images/3241e37b3ed748d4a38d7d5993841e92.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMjkxMDY=",
        "name": "STR",
        "logoUrl": "https://static.swapcard.com/public/images/5c1261ee761c47c48ff47629266802a1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMzkyMjQ=",
        "name": "Sophos Hotels ",
        "logoUrl": "https://static.swapcard.com/public/images/da47d2dbf21d42828456c4f4c78f8b0d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMzkyMjU=",
        "name": "Hospitality Chain Co",
        "logoUrl": "https://static.swapcard.com/public/images/84125e6a94d34e799d4cae6dd2639a19.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxMzkyMzc=",
        "name": "TravTalk",
        "logoUrl": "https://static.swapcard.com/public/images/b0c62fac803d4e2a93901a6fb17318e1.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNDA2NzU=",
        "name": "H World International",
        "logoUrl": "https://static.swapcard.com/public/images/e797bb0fcb3a4ecc9bbfda04afcad058.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNDA3MDc=",
        "name": "The First Group Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/eac8ef04f5dd42b5bf0ae9cdbdef5e13.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNDA4Mjk=",
        "name": "ELE|NA",
        "logoUrl": "https://static.swapcard.com/public/images/169165940f8f4e35bd70f44713831a03.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNDQ5MjM=",
        "name": "Breaking Travel News",
        "logoUrl": "https://static.swapcard.com/public/images/565195d3a5574a06992b38dbd9df1b76.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MDI=",
        "name": "Elaf Group",
        "logoUrl": "https://static.swapcard.com/public/images/61a04d9a466342958b53a2211dd8556e.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MDc=",
        "name": "Sommet Education",
        "logoUrl": "https://static.swapcard.com/public/images/8e16c4adc4aa4350871ed005a0e8cc33.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MTQ=",
        "name": "CBRE Middle East",
        "logoUrl": "https://static.swapcard.com/public/images/20e3e10c8b0e4600aab57e142d596191.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MTU=",
        "name": "Hospitality Management Holding",
        "logoUrl": "https://static.swapcard.com/public/images/460ba738383e4bc6bde01384d73b3332.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MzI=",
        "name": "Travel & Tourism News Middle East",
        "logoUrl": "https://static.swapcard.com/public/images/98f32dbc8a9348da8b99fdc0598ec6f9.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1MzQ=",
        "name": "Finance World Magazine",
        "logoUrl": "https://static.swapcard.com/public/images/9bf72700cb724ad6af70a38f683c6af9.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTM1NzY=",
        "name": "TV5Monde",
        "logoUrl": "https://static.swapcard.com/public/images/ad9fd3e87c00467686a48188bb17c201.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTc4NjA=",
        "name": "Hospitality Net",
        "logoUrl": "https://static.swapcard.com/public/images/b10e60ea8bea43879ad2e453e2b8c84b.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTk5NTM=",
        "name": "United Hospitality Management",
        "logoUrl": "https://static.swapcard.com/public/images/4a3535be4597488690f148c3dd7bf44f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNTk5NTc=",
        "name": "Dusit International",
        "logoUrl": "https://static.swapcard.com/public/images/015832897d8d421e90ead82cda176708.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNjE0MTE=",
        "name": "Argaam",
        "logoUrl": "https://static.swapcard.com/public/images/3b91d7804ab24a98b5b9ae2878cea33d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzA0Nzc=",
        "name": "BARAKA",
        "logoUrl": "https://static.swapcard.com/public/images/17f7d151c7834a1c835e3f43565ea236.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzA0Nzg=",
        "name": "IHG Hotels & Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/a4d93087d90f4053b6e19e28c0c6ab57.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNDQ3NDE0MA==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzE4OTk=",
        "name": "World Sustainable Hospitality Alliance",
        "logoUrl": "https://static.swapcard.com/public/images/a8a80d1c4f2345968e19c9df09d93512.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjcwNDI5MQ==",
                "value": "supporters",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzE5MDA=",
        "name": "World Travel & Tourism Council",
        "logoUrl": "https://static.swapcard.com/public/images/0076c0ff74f34971b4ab579389f5b7f8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjcwNDI5MQ==",
                "value": "supporters",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzE5MDE=",
        "name": "UN Tourism",
        "logoUrl": "https://static.swapcard.com/public/images/8d1f97b7d7e54f8dad09130ceb4aeb7b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjcwNDI5MQ==",
                "value": "supporters",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzQwOTY=",
        "name": "Eye of Riyadh",
        "logoUrl": "https://static.swapcard.com/public/images/15a2e598b6eb4745a3688fd5e961276b.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxNzQ2NjI=",
        "name": "Horwath HTL",
        "logoUrl": "https://static.swapcard.com/public/images/9d92e41aeea84f8d8a4639d2f270ca44.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxODgwNjY=",
        "name": "Travel and Tour World",
        "logoUrl": "https://static.swapcard.com/public/images/2fc4b7e0ae6a454db5514fbf445a80d0.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxOTQyNTE=",
        "name": "World Sustainable Travel & Hospitality Awards",
        "logoUrl": "https://static.swapcard.com/public/images/8a691081f27e4dc4bcf1fd68480ee44f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjcwNDI5MQ==",
                "value": "supporters",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxOTQ4OTU=",
        "name": "Inntelo AI",
        "logoUrl": "https://static.swapcard.com/public/images/691ac82347574ccbb4375315ad362030.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NzQwMA==",
                "value": "startup-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Startup Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxOTU2Nzg=",
        "name": "Colliers",
        "logoUrl": "https://static.swapcard.com/public/images/b1566185a4924542a981aebd3cca21fa.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxOTcxOTY=",
        "name": "Connecting Travel",
        "logoUrl": "https://static.swapcard.com/public/images/363bd1abe73f475e8f10b72cd1b0f8e7.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIxOTg5MTU=",
        "name": "Arab News",
        "logoUrl": "https://static.swapcard.com/public/images/a3d0fdfb1b644ae7a833c91aba45bc6e.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDEzODE=",
        "name": "Hospitality News Middle East",
        "logoUrl": "https://static.swapcard.com/public/images/64fa41e596934caeaa4f0088ffb66894.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNjAzMTE4Mg==",
                "value": "media-partners",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDI4ODA=",
        "name": "Deloitte Middle East",
        "logoUrl": "https://static.swapcard.com/public/images/25f02131a07f4e91b163188989983ea2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDQwMzA=",
        "name": "AQUIVIO Arabia LLC",
        "logoUrl": "https://static.swapcard.com/public/images/f8ac2f4899844656b515ed29f911e022.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NzQwMA==",
                "value": "startup-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Startup Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDQwMzE=",
        "name": "The Natural Bottle",
        "logoUrl": "https://static.swapcard.com/public/images/3fbd21aa640347eeb5c9047b77be3b02.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NzQwMA==",
                "value": "startup-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Startup Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDQ1MDY=",
        "name": "trustangle",
        "logoUrl": "https://static.swapcard.com/public/images/22c43617a39747a0b895b9f6493afa72.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDU0MjM=",
        "name": "Jabal Omar Development Company",
        "logoUrl": "https://static.swapcard.com/public/images/8a8103612b5c440b8768e50488c63e2d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMDg3MTc=",
        "name": "Baker McKenzie",
        "logoUrl": "https://static.swapcard.com/public/images/d2fa358829a8450b8c07cdd42920b394.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTA3MTA=",
        "name": "Aristara",
        "logoUrl": "https://static.swapcard.com/public/images/95909be71d8f40e4ace9932eaa8dcb02.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyNQ==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTA4NjA=",
        "name": "ALTANFEETHI",
        "logoUrl": "https://static.swapcard.com/public/images/15520acef2a949e5984bacfee7eed467.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNTY2Ng==",
                "value": "hospitality-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Hospitality Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTEwNzM=",
        "name": "Growth Partner",
        "logoUrl": "https://static.swapcard.com/public/images/71ef25510c384b0ca8ee924a81974e12.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk3OTkyMw==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTIwNjQ=",
        "name": "RIKAZ",
        "logoUrl": "https://static.swapcard.com/public/images/31dbd41153034508b6faccc2f83139db.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzQ0NjA5Nw==",
                "value": "experiential-developer",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Experiential Developer"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTIxODg=",
        "name": "New Murabba",
        "logoUrl": "https://static.swapcard.com/public/images/69e49aa5d6154b71b6c3523d75896d29.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzk2Njg1OA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMTI4ODc=",
        "name": "VOXO",
        "logoUrl": "https://static.swapcard.com/public/images/a3ae70b279744d19abe09e410ee0f3e2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzQ2MzE3OQ==",
                "value": "ai-summary-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzcxMzU0Nw==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "AI Summary Partner"
                    }
                ]
            }
        ]
    }
]
}